import React from 'react';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input from 'material-ui/Input';
import { Badge } from 'reactstrap';

import { filter } from 'lodash'

export const colorList = [
    { id: 1, value: '255,0,0', color: 'danger', label: 'Red', },
    { id: 2, value: '0,0,255', color: 'primary', label: 'Blue', },
    { id: 3, value: '0,100,0', color: 'success', label: 'Green', },
    { id: 4, value: '255,100,0', color: 'bg-orange', label: 'Orange', },
    { id: 5, value: '255,215,0', color: 'bg-amber', label: 'Yellow', },
    { id: 6, value: '0,0,0', color: 'bg-black', label: 'Black', },
]
class SelectColor extends React.Component {
    render() {
        const { value, handleChange } = this.props
        return (
            <Select value={value}
                onChange={handleChange.bind(this)}
                input={<Input id="age-simple" />} >
                <MenuItem key='1' value='' style={{ fontWeight: '500' }}>
                    Select a color
                </MenuItem>
                {colorList.map((data, index) => {
                    return (<MenuItem key={data.id} value={data.value} style={{ fontWeight: '500' }}>
                        <Badge className={data.color + " d-block text-white"} color={data.color}>{data.label}</Badge>
                    </MenuItem>);
                })}

                {/* <MenuItem key='2' value='255,0,0' style={{ fontWeight: '500' }}>
                    <Badge className="d-block danger text-white" color="danger">Red</Badge>
                </MenuItem>
                <MenuItem key='3' value='0,0,255' style={{ fontWeight: '500' }}>
                    <Badge className="d-block primary text-white" color="primary">Blue</Badge>
                </MenuItem>
                <MenuItem key='4' value='0,100,0' style={{ fontWeight: '500' }}>
                    <Badge className="d-block success text-white" color="success">Green</Badge>
                </MenuItem>
                <MenuItem key='5' value='255,100,0' style={{ fontWeight: '500' }}>
                    <Badge className="d-block bg-orange text-white" color="orange">Orange</Badge>
                </MenuItem>
                <MenuItem key='6' value='255,215,0' style={{ fontWeight: '500' }}>
                    <Badge className="d-block bg-amber text-white" color="yellow">Yellow</Badge>
                </MenuItem>
                <MenuItem key='7' value='0,0,0' style={{ fontWeight: '500' }}>
                    <Badge className="d-block bg-black text-white" color="black">Black</Badge>
                </MenuItem> */}
            </Select>
        );
    }
}
export default SelectColor;




// WEBPACK FOOTER //
// ./app/selectcolor.js